import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

const moment = require('moment');

/**
 * Obtener todas las comparaciones realizadas.
 * @author Jhon García
 */
export async function obtenerComparaciones({commit, state}) {

    const parametros = {
        params: state.filtros
    };

    if (!state.filtros.id_empresa) {
        commit('establecerComparaciones', {data: []});
    } else {

        commit('dashboard/load', true, {root: true});

        await $http.get(`/matriz-compatibilidad/almacenamiento/comparaciones`, parametros)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});
                commit('establecerComparaciones', response.data.data);
            })
            .catch(async (error) => {
                commit('dashboard/load', false, {root: true});

                await Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.errors,
                    showConfirmButton: true,
                    timer: 3000
                });
            });
    }
}

/**
 * Obtener comparación de acuerdo al id del mismo
 * @author Jhon García
 */
export async function obtenerComparacion({commit, state, dispatch}, {id, id_empresa}) {

    await dispatch('obtenerUbicaciones', id_empresa);

    commit('dashboard/load', true, {root: true});

    await $http.get(`/matriz-compatibilidad/almacenamiento/comparaciones/${id}/${id_empresa}`)
        .then(async (response) => {
            commit('establecerEmpresas', [response.data.data.empresa]);
            commit('dashboard/load', false, {root: true});
            commit('establecerComparacion', response.data.data);
        })
        .catch(async (error) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.errors,
                showConfirmButton: true,
                timer: 3000
            });
        });
}

/**
 * Guardar comparación.
 * @author Jhon García
 */
export async function guardarComparacion({commit, state}, id_empresa) {

    if(id_empresa){
        state.comparacion.id_empresa = id_empresa;
    }

    return await new Promise(async (resolve, reject) => {
        commit('dashboard/load', true, {root: true});

        await $http.post(`/matriz-compatibilidad/almacenamiento/comparaciones`, state.comparacion)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});
                commit('establecerComparacion', response.data.data);

                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: true,
                    timer: 3000
                });

                resolve(response.data.data);
            })
            .catch(async (error) => {
                commit('dashboard/load', false, {root: true});

                await Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.errors,
                    showConfirmButton: true,
                    timer: 3000
                });
                reject();
            });
    });
}

/**
 * Guardar comparación.
 * @author Jhon García
 */
export async function actualizarComparacion({commit, state}) {

    commit('dashboard/load', true, {root: true});

    commit('establecerProductoComparaciones');

    await $http.put(`/matriz-compatibilidad/almacenamiento/comparaciones/${state.comparacion.id}`, state.comparacion)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('establecerComparacion', response.data.data);

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 3000
            });
        })
        .catch(async (error) => {
            commit('dashboard/load', false, {root: true});

            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.errors,
                showConfirmButton: true,
                timer: 3000
            });
        });
}

/**
 * Obtener empresas
 */
export async function obtenerEmpresas({dispatch, commit, state}, nombre) {
    state.comparacion.resultConfig = undefined;
    dispatch('obtenerEmpresasPeticion', nombre)
        .then(empresas => commit('establecerEmpresas', empresas));
}

/**
 * Obtener empresas filtro
 */
export async function obtenerEmpresasFiltro({commit, dispatch}, nombre) {
    dispatch('obtenerEmpresasPeticion', nombre)
        .then(empresas => commit('establecerEmpresasFiltro', empresas));
}

/**
 * Obtener empresas desde el back
 */
export async function obtenerEmpresasPeticion({dispatch, commit, state}, nombre) {

    return await new Promise(async (resolve, reject) => {
        if (!state.cargando_datos_select && nombre && nombre.length > 1) {
            commit('establecerCargandoDatosSelect', true);

            let parametros = {
                params: {
                    nombre: nombre
                }
            };

            await $http.get('/empresas/lista', parametros)
                .then((response) => {
                    resolve(response.data.data);
                    commit('establecerCargandoDatosSelect', false);
                })
                .catch(() => {
                    console.warn('No se encontraron empresas con el nombre especificado');
                    reject([]);
                    commit('establecerCargandoDatosSelect', false);
                });
        }
    });
}

/**
 * Obtener empresas
 */
export async function obtenerUbicaciones({dispatch, commit, state}, id_empresa) {
    state.comparacion.resultConfig = undefined;
    await dispatch('obtenerUbicacionesPeticion', id_empresa)
        .then(ubicaciones => commit('establecerUbicaciones', ubicaciones));
}

/**
 * Obtener ubicaciones filtro
 */
export async function obtenerUbicacionesFiltro({commit, dispatch}, id_empresa) {
    dispatch('obtenerUbicacionesPeticion', id_empresa)
        .then(ubicaciones => commit('establecerUbicacionesFiltro', ubicaciones));
}

/**
 * Obtener empresas desde el back
 */
export async function obtenerUbicacionesPeticion({dispatch, commit, state}, id_empresa) {
    return await new Promise(async (resolve, reject) => {
        if (id_empresa) {
            commit('dashboard/load', true, {root: true});
            await $http.get(`company/location/tree/${id_empresa}`)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    resolve(response.data.data);
                }).catch(() => {
                    commit('dashboard/load', false, {root: true});
                    reject([]);
                });
        } else {
            resolve([]);
        }
    });
}

/**
 * Obtener empresas desde el back
 */
export async function obtenerProductos({dispatch, commit, state}) {

    let filtros_productos = state.filtros_productos;

    filtros_productos.id_empresa = state.comparacion.id_empresa;

    if (!filtros_productos.id_ubicacion) {
        filtros_productos.id_ubicacion = state.comparacion.id_ubicacion;
        commit('establecerIdUbicacionFiltrosProductos', state.comparacion.id_ubicacion);
    }

    const parametros = {
        params: filtros_productos
    };

    commit('dashboard/load', true, {root: true});
    await $http.get(`/productos-por-ubicacion`, parametros)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('establecerProductos', response.data.data);
        }).catch(async () => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.errors,
                showConfirmButton: true,
                timer: 3000
            });
        });

}

export async function obtenerFabricantes({commit, state}, nombre) {

    if (!state.cargando_datos_select && nombre && nombre.length > 2) {
        commit('establecerCargandoDatosSelect', true);
        commit('dashboard/load', true, {root: true});

        let parametros = {
            params: {
                nombre: nombre
            }
        };

        await $http.get('/fabricantes', parametros)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('establecerCargandoDatosSelect', false);
                commit('establecerFabricantes', response.data.fabricantes);
            })
            .catch(() => {
                commit('dashboard/load', false, {root: true});
                commit('establecerCargandoDatosSelect', false);
            });
    }
}

export async function descargarExcel({state, commit}, comparacion) {

    const empresa = comparacion.empresa;

    const fecha = moment().format('yyyy_MM_DD');

    let nombre_archivo = 'MATRIZ_COMPATIBILIDAD_' + empresa.nombre + '_' + fecha + '.xlsx';

    commit('dashboard/load', true, {root: true});

    await $http({
        url: 'matriz-compatibilidad/almacenamiento/comparaciones/excel/' + comparacion.id + '/' + comparacion.id_empresa,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        window.downloadFile(response.data, nombre_archivo)
        commit('dashboard/load', false, {root: true});
    }).catch((error) => {
        Swal.fire({
            title: 'Error',
            icon: 'error',
            text: 'No ha configurado los resultados desde la administración',
            type: 'error',
            confirmButtonText: 'Aceptar',
          })
        commit('dashboard/load', false, {root: true});
    });
}

/**
 * Eliminar
 */
export async function eliminarComparacion({commit, state, dispatch}, comparacion) {
    Swal.fire({
        title: 'Eliminar registro',
        text: '¿Está seguro de eliminar el registro?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar',
    }).then(async (result) => {
        if (result.isConfirmed) {
            commit('dashboard/load', true, {root: true});
            await $http.delete('matriz-compatibilidad/almacenamiento/comparaciones/' + comparacion.id + '/' + comparacion.id_empresa)
                .then(async (response) => {
                    await dispatch('obtenerComparaciones');
                    commit('dashboard/load', false, {root: true});
                    await Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien!',
                        text: response.data.message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                }).catch((error) => {
                    commit('dashboard/load', false, {root: true});
                });
        }
    });
}

export async function descargarExcelGenerico({commit}, empresa_id) {
    const fecha = moment().format('yyyy_MM_DD');
    let nombre_archivo = 'MATRIZ_COMPATIBILIDAD_GENERICA_' + fecha + '.xlsx';
    commit('dashboard/load', true, {root: true});
    await $http({
        url: 'matriz-compatibilidad/almacenamiento/comparaciones/excel-generico/' + empresa_id,
        method: 'POST',
        responseType: 'blob',
    }).then((response) => {
        window.downloadFile(response.data, nombre_archivo)
        commit('dashboard/load', false, {root: true});
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
    });
}

/**
 * Guardar la compatibilidad en el historial de comparaciones
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} history - Historial de compatibilidad.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function saveHistoryCompatibility({commit}, history) {
    try {
     commit('dashboard/load', true, {root: true});
     const res = await $http.post('matriz-compatibilidad/save-history', history)
     return res.data;
    } catch (error) {
     commit('dashboard/load', false, {root: true});
     if (this.$vue.$alertErrorsCallback(error)) return;
     this.$vue.$alertError(error.message);
    } finally {
     commit('dashboard/load', false, {root: true});
    }
 }
